module.exports = __webpack_public_path__ + "img/icon_popup_arrow_open.c201e12a.svg";